export const ANCHOR_ENABLED_TEMPLATES = new Set(['t4', 't5', 't10', 't20', 't21']);

const UUID_FRAGMENT_PATTERN =
  /^([0-9a-fA-F]{8})-(([0-9a-fA-F]{4}-){3})([0-9a-fA-F]{12})$/i;

export function isAnchorFragment(fragment: string | null | undefined): fragment is string {
  return !!fragment && UUID_FRAGMENT_PATTERN.test(fragment);
}
